import { authClient } from './index';

import Cookie from 'universal-cookie';
import { toast } from 'react-toastify';

const cookies = new Cookie();

const config = {
  headers: {
    'Content-Type': 'application/json',
    authorization: `Bearer ${cookies.get('authToken')}`,
  },
};

// {}
export const getMyProducts  = async (data) => {
  const {authToken, pageNumber, pageSize, searchText, startDate, endDate} = data;

  const configDash = {
    headers: {
      authorization: `Bearer ${data.authToken}`,
    },
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/vendor/my-product?pageSize=${pageSize || 25}&pageNumber=${pageNumber || 1}${searchText ? `&search=${searchText}` : ""  }${startDate ? `&startDate=${startDate.toISOString()}` : ""}${endDate ? `&endDate=${endDate.toISOString()}` : ""}`, configDash)
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
// Fetch All products

// export const getMyProducts = async (data) => {
//   const myConfig = {
//     headers: {
//       authorization: `Bearer ${data.authToken}`,
//     },
//   };
//   return new Promise(async (resolve, reject) => {
//     try {
//       const res = await authClient.get('/vendor/my-product', myConfig);
//       resolve(res);
//     } catch (error) {
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 401) {
//           cookies.remove('authToken', { path: '/' });
//           cookies.remove('user', { path: '/' });
//           cookies.remove('userId', { path: '/' });
//           toast.error('Your session has expired. Please login again.');
//           window.location.href = '/auth/sign-in';
//         } else if (status === 400) {
//           toast.error(data.message || 'Bad Request: Invalid request data.');
//         } else if (status === 403) {
//           toast.error('Forbidden: You do not have permission to access this resource.');
//         } else if (status === 404) {
//           toast.error('Not Found: The requested product could not be found.');
//         } else if (status === 500) {
//           toast.error('Server Error: Please try again later.');
//         } else {
//           toast.error(data.message || 'An error occurred while fetching the product details.');
//         }
//       } else if (error.request) {
//         toast.error('Network Error: Please check your internet connection and try again.');
//       } else {
//         toast.error('Error: ' + error.message);
//       }
//       reject(error);
//     }
//   });
// };

// UnPublish Product
export const unPublishProduct = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post('/vendor/unpublish-product', data, config);
      resolve(res);
    } catch (error) {
      let errorMessage = 'An error occurred while unpublishing the product.';
      
      if (error.response) {
        const { status, data } = error.response;
        
        if (status === 400) {
          errorMessage = 'Bad Request: ' + (data.message || 'Invalid request data.');
        } else if (status === 401) {
          errorMessage = 'Unauthorized: Please login to continue.';
        } else if (status === 403) {
          errorMessage = 'Forbidden: You do not have permission to unpublish this product.';
        } else if (status === 404) {
          errorMessage = 'Not Found: The product could not be found.';
        } else if (status === 500) {
          errorMessage = 'Server Error: Please try again later.';
        }
      } else if (error.request) {
        errorMessage = 'Network Error: Please check your internet connection and try again.';
      } else {
        errorMessage = 'Error: ' + error.message;
      }

      toast.error(errorMessage);
      reject(new Error(errorMessage));
    }
  });
};

export const launchProduct = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post('/vendor/launch-product', data, config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Customer Stats Api Client
export const viewCustomerStats = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post('/vendor/launch-product', data, config);
      resolve(res);
    } catch (error) {
      let errorMessage = 'An error occurred while unpublishing the product.';
      
      if (error.response) {
        const { status, data } = error.response;
        
        if (status === 400) {
          errorMessage = 'Bad Request: ' + (data.message || 'Invalid request data.');
        } else if (status === 401) {
          errorMessage = 'Unauthorized: Please login to continue.';
        } else if (status === 403) {
          errorMessage = 'Forbidden: You do not have permission to unpublish this product.';
        } else if (status === 404) {
          errorMessage = 'Not Found: The product could not be found.';
        } else if (status === 500) {
          errorMessage = 'Server Error: Please try again later.';
        }
      } else if (error.request) {
        errorMessage = 'Network Error: Please check your internet connection and try again.';
      } else {
        errorMessage = 'Error: ' + error.message;
      }

      toast.error(errorMessage);
      reject(new Error(errorMessage));
    }
  });
};

// Vendor Stats Api Client
export const viewVendorStats = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post('/vendor/stats-summary', data, config);
      resolve(res);
    } catch (error) {
      let errorMessage = 'An error occurred while unpublishing the product.';
      
      if (error.response) {
        const { status, data } = error.response;
        
        if (status === 400) {
          errorMessage = 'Bad Request: ' + (data.message || 'Invalid request data.');
        } else if (status === 401) {
          errorMessage = 'Unauthorized: Please login to continue.';
        } else if (status === 403) {
          errorMessage = 'Forbidden: You do not have permission to unpublish this product.';
        } else if (status === 404) {
          errorMessage = 'Not Found: The product could not be found.';
        } else if (status === 500) {
          errorMessage = 'Server Error: Please try again later.';
        }
      } else if (error.request) {
        errorMessage = 'Network Error: Please check your internet connection and try again.';
      } else {
        errorMessage = 'Error: ' + error.message;
      }

      toast.error(errorMessage);
      reject(new Error(errorMessage));
    }
  });
};

// Product Detail Api Client
export const getProductDetail = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/products/product/${data}`, config);
      resolve(res);
    } catch (error) {
      let errorMessage = 'An error occurred while unpublishing the product.';
      
      if (error.response) {
        const { status, data } = error.response;
        
        if (status === 400) {
          errorMessage = 'Bad Request: ' + (data.message || 'Invalid request data.');
        } else if (status === 401) {
          errorMessage = 'Unauthorized: Please login to continue.';
        } else if (status === 403) {
          errorMessage = 'Forbidden: You do not have permission to unpublish this product.';
        } else if (status === 404) {
          errorMessage = 'Not Found: The product could not be found.';
        } else if (status === 500) {
          errorMessage = 'Server Error: Please try again later.';
        }
      } else if (error.request) {
        errorMessage = 'Network Error: Please check your internet connection and try again.';
      } else {
        errorMessage = 'Error: ' + error.message;
      }

      toast.error(errorMessage);
      reject(new Error(errorMessage));
    }
  });
};

//Resubmit Product
export const reSubmit = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        `vendor/resubmit-product`,
        data,
        config,
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

//Edit Product
export const editProduct = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.patch(`/vendor/edit-product`, data, config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Add Coupon Api Client
export const addCoupon = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post('/vendor/add-coupon', data, config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Add Coupon Api Client
export const fetchAllCoupons = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get('/vendor/all-coupon', configDash);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Delete Coupon Api Client
export const deleteCoupons = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data.authToken}`,
    },
  };

  const formData = {
    code: data.code,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        '/vendor/delete-coupon',
        formData,
        configDash,
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Deactivate Coupon Api Client
export const deactivateCoupons = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data.authToken}`,
    },
  };

  const formData = {
    code: data.code,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        '/vendor/deactivate-coupon',
        formData,
        configDash,
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
// Deactivate Coupon Api Client
export const activateCoupons = async (data) => {
  const configDash = {
    headers: {
      authorization: `Bearer ${data.authToken}`,
    },
  };

  const formData = {
    code: data.code,
  };

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(
        '/vendor/activate-coupon',
        formData,
        configDash,
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
// Deactivate Coupon Api Client
export const editCoupons = async (data) => {
  const config = {
    headers: {
      authorization: `Bearer ${data.authToken}`,
    },
  };

  const formData = data.values;

  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.patch(
        '/vendor/edit-coupon',
        formData,
        config,
      );
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
